import React from "react";

export default () => (
	<section id="cta">
		<div className="section_contents">
			<div className="recruit_links">
				<div className="links_item mainavi">
					<p className="text">新卒採用にご応募の方はこちら</p>
					<a
						className="btn"
						href="https://job.mynavi.jp/27/pc/search/corp92309/outline.html"
						target="_blank"
						rel="noopener noreferrer"
					>
						<picture>
							<source
								srcSet="images/common/mainavi.webp"
								type="image/webp"
							/>
							<img
								src="images/common/mainavi.png"
								alt="マイナビ"
							/>
						</picture>
					</a>
					{/* <a
            className="btn"
            href="https://job.rikunabi.com/2026/company/r620230017/"
            target="_blank"  rel="noopener noreferrer"
          >
            <picture>
              <source srcSet="images/common/rikunavi.webp" type="image/webp" />
              <img src="images/common/rikunavi.png" alt="リクナビ2026" />
            </picture>
          </a> */}
				</div>
				<div className="links_item entry">
					<p className="text">中途採用にご応募の方はこちら</p>
					<a
						className="btn"
						target="_blank"
						href="https://www.lyzon.co.jp/recruit-form"
						rel="noopener noreferrer"
					>
						ENTRY
					</a>
				</div>
			</div>
		</div>
	</section>
);



// WEBPACK FOOTER //
// ./src/Home/cta.js